import classes from "./ProgressModal.module.css";

const formatDuration = (ms = 0) => {
  if (!ms || Number.isNaN(ms)) return "--";
  const seconds = Math.floor(ms / 1000);
  const mins = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${mins}m ${remainingSeconds}s`;
};

const formatDateTime = (iso) => {
  if (!iso) return "--";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "--";
  return date.toLocaleString();
};

export default function ProgressModal({
  progressState = {},
  total = 0,
  importDone = false,
  durationMs = null,
  startedAt = null,
  onViewProducts,
  onClose,
}) {
  const {
    processed = 0,
    imported = 0,
    skipped = 0,
    skippedList = [],
  } = progressState;

  const percent = total > 0 ? Math.round((processed / total) * 100) : 0;

  return (
    <div className={classes.overlay}>
      <div className={classes.modal}>
        <header className={classes.header}>
          <h4>Importing Products</h4>
        </header>

        <div className={classes.body}>
          <div className={classes.progressWrap}>
            <div className={classes.progressBar}>
              <div
                className={classes.progressFill}
                style={{ width: `${percent}%` }}
              />
            </div>

            <div className={classes.progressMeta}>
              <div>{percent}%</div>
              <div>
                {processed} / {total} processed
              </div>
            </div>
          </div>

          <div className={classes.summary}>
            <div>
              Imported <strong>{imported}</strong>
            </div>
            <div>
              Skipped <strong>{skipped}</strong>
            </div>
          </div>

          <div className={classes.metaGrid}>
            <div className={classes.metaItem}>
              <span>Started</span>
              <strong>{formatDateTime(startedAt)}</strong>
            </div>
            <div className={classes.metaItem}>
              <span>Duration</span>
              <strong>
                {durationMs !== null ? formatDuration(durationMs) : "--"}
              </strong>
            </div>
            <div className={classes.metaItem}>
              <span>Total Rows</span>
              <strong>{total}</strong>
            </div>
          </div>

          <div className={classes.skippedList}>
            <h5>Skipped / Duplicates</h5>

            {skippedList.length === 0 ? (
              <div className={classes.empty}>None</div>
            ) : (
              <div className={classes.table}>
                <div className={classes.trHead}>
                  <div>Row</div>
                  <div>SKU</div>
                  <div>Reason</div>
                </div>

                {skippedList.map((s, idx) => (
                  <div className={classes.tr} key={idx}>
                    <div>{s.row ?? "-"}</div>
                    <div>{s.sku || "-"}</div>
                    <div>{s.reason}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <footer className={classes.footer}>
          {importDone && (
            <button className={classes.viewBtn} onClick={onViewProducts}>
              View Products
            </button>
          )}

          <button className={classes.closeBtn} onClick={onClose}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}
